export default "__VITE_ASSET__CeKvADcI__"